import { swSettings } from "app/common/services/swSettings";

export const MODAL_CONFIG = {
    styles: {
        content: {
            padding: "12px 12px 20px",
            width: "354px",
        },
    },
    closeIcon: {
        show: false,
    },
} as const;

export const TEAM_INVITE_IMAGE = "/images/users-add-on-modal.png";

export const getAddOnsUrl = (): string =>
    `${swSettings.swsites.login}${swSettings.components.HookWorkspace.resources.NtAddOnPackagesUrl}?packageType=1`;

export const TRACKING_CATEGORY = "Addons";

export const TRACKING_EVENT_NAME = "additional user";
